export default __webpack_public_path__ + "static/media/AllProductDeleteFilter.74e5b09a.svg";